import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IOrderState } from './order.types';
import { IOrderData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IOrderState = {
  version: 1,
  orders: [] as IOrderData[],
  count: 0,
  lastPromise: null
};

const namespaced = true;

export const order: Module<IOrderState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
